(function () {
  // Sticky-bar verschijnt pas wanneer de hoofd-ATC volledig uit beeld is gescrolld.
  function bindScrollVisibility(panel, productSection) {
    const mainForm =
      productSection.querySelector('form.js-product-form-main') ||
      productSection.querySelector('product-form form.js-product-form') ||
      productSection.querySelector('product-form form') ||
      productSection.querySelector('form[action^="/cart/add"]');
    if (!mainForm) return;

    if (!('IntersectionObserver' in window)) {
      panel.classList.remove('sticky-atc-panel--out');
      return;
    }

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // boundingClientRect.bottom < 0 => mainForm zit boven viewport (klant heeft 'm voorbij gescrolld)
        const isScrolledPast = entry.boundingClientRect.bottom < 0;
        panel.classList.toggle('sticky-atc-panel--out', !isScrolledPast);
      });
    }, { threshold: 0 });

    observer.observe(mainForm);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-sticky-atc-panel]').forEach((el) => {
      const productSection = el.closest('.cc-main-product') || document;
      bindScrollVisibility(el, productSection);
    });
  });
})();
